<template>
  <div class="login-wrap" v-loading="loading">
    <div class="ms-title">登录</div>
    <div class="ms-login">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
        <el-form-item prop="username">
          <el-input v-model="ruleForm.username" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" placeholder="密码" v-model="ruleForm.password"
                    @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="login-btn-submit" type="primary" @click="submitForm('ruleForm')">登录</el-button>
          <el-button type="danger" :plain="true" @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
	<div>
    <el-link href="" target="_blank" class="pic">鲁ICP备2023042173号-1</el-link>
  </div>
  </div>
</template>

<script>
import Utils from "../../Utils.vue";

export default {
  data: function () {
    return {
      ruleForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ]
      },
      loading: false
    }
  },
  methods: {
    submitForm(formName) {
      const self = this;
      self.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          const param = 'username=' + self.ruleForm.username
            + "&password=" + self.ruleForm.password
          self.$http.get(this.$global.baseUrl + 'login?' + param)
            .then((response) => {
              if (response.data.state === 0) {
                if (response.data.object.token) {
                  self.$message.success("登录成功");
                  self.$utils.saveUsername(response.data.object.username);
                  self.$utils.saveUserId(response.data.object.id);
                  self.$utils.saveToken(response.data.object.token);
                  self.$router.replace('/home');
                } else {
                  self.$message.warning("登录失败")
                }
              } else {
                self.$message.warning(response.data.message)
              }
              this.loading = false;
            }).catch((error) => {
            this.loading = false;
            self.$message.warning(error.message)
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scoped>
.login-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.ms-title {
  position: absolute;
  top: 50%;
  width: 100%;
  margin-top: -230px;
  text-align: center;
  font-size: 30px;
  color: #000000;
}

.ms-login {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 300px;
  height: 160px;
  margin: -150px 0 0 -190px;
  padding: 40px;
  border-radius: 5px;
  background-color: aquamarine;
}

.login-btn-submit {
  width: 215px;
}
.pic {
position: fixed;
bottom: 0;
left: 50%;/*相对于可视区窗口，距离窗口左边50%个可视区窗口*/
margin-left:-100px ;/*表格左边距离浏览器左边50%，向左偏移一半的身位表格即可居中*/
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Login.vue